export const SET_STATS_TABLE = 'SET_STATS_TABLE';
